<template>
<div >
    <div class="form-row">
        <div class="col-3">
            <select class="form-control" v-model="selected.d" @change="validate();changed()" :class="{'is-invalid':invalidDate}" >
                <option v-for="day in days" :key="day" :value="day">{{day}}</option>
            </select>
        </div>
        <div class="col-5 p-0">
            <select class="form-control" v-model="selected.m" @change="validate();changed()" :class="{'is-invalid':invalidDate}" >
                <option v-for="month in months" :key="month" :value="month">{{ [2007, month-1, 15] | moment('MMMM')}}</option>
            </select>
        </div>
        <div class="col-4">
            <select class="form-control" v-model="selected.y" @change="validate();changed()" :class="{'is-invalid':invalidDate}" >
                <option v-for="year in years" :key="year" :value="year">{{year}}</option>
            </select>
        </div>
    </div>
</div>

</template>

<script>

export default {
	name: "InputDate",
    props:['value'],
	data(){
		return{
            selected:{
                d:'',
                m:'',
                y:'',
            },
            days:[],
            months:[],
            years:[],
            invalidDate:false,
		}
    },
    beforeMount(){
      this.createDates();  
      this.formatSelectedDate();
    },
    watch:{
        value(){
            this.formatSelectedDate();    
        }
    },
	methods:{
        formatSelectedDate(){
            this.selected.d = this.$moment(this.value).format('DD');
            this.selected.m = this.$moment(this.value).format('MM');
            this.selected.y = this.$moment(this.value).format('YYYY');
        },
        changed(){
            this.$emit('change');
        },
        pad(str, max) {
            str = str.toString();
            return str.length < max ? this.pad("0" + str, max) : str;
        },
        createDates(){
            for(let d=1;d<=31;d++){ this.days.push(this.pad(d,2)); }
            for(let m=1;m<=12;m++){ this.months.push(this.pad(m,2)); }
            let yTo = this.$moment().subtract(90,'years').format('YYYY');
            let y = this.$moment().subtract(17,'years').format('YYYY');
            for(y;y>=yTo;y--){ this.years.push(y); }
        },
        validate(){
            this.invalidDate = false;
            if( this.selected.d && this.selected.m && this.selected.y ){
                let selectedDate = this.$moment(this.selected.y + '-' + this.selected.m + '-' + this.selected.d,'YYYY-MM-DD');

                if( selectedDate.isValid() ){
                    //console.log('fecha valida',selectedDate);
                    this.$emit('validated', selectedDate)
                }else{
                    //console.log('fecha INVALIDA',selectedDate);
                    this.invalidDate = true;
                }
            }
        },
        
    },
    
};
</script>

<style scoped>

</style>
